<template>
  <div>
    <div class="salon-list-header">
      <h1 class="salon-list-title-main">SALON LIST</h1>
      <p class="salon-list-title-sub">店舗一覧</p>
    </div>
    <div class="salon-list-container">
      <div 
        v-bind:class="{'area-classification':!areaClassificationShow[areaClassification.area],
                       'area-classification-active':areaClassificationShow[areaClassification.area]}"
        v-for="(areaClassification) in salonList" 
        :key="areaClassification"
      >
        <div 
          v-bind:class="{'area-classification-button':!areaClassificationShow[areaClassification.area],
                         'area-classification-button-active':areaClassificationShow[areaClassification.area]}"
          v-on:click="areaClassificationShow[areaClassification.area] = !areaClassificationShow[areaClassification.area]"
        >
          {{ areaClassification.area }} 
        </div>
        <div v-show="areaClassificationShow[areaClassification.area]">
          <div v-for="(salonPrefecture) in areaClassification.prefectures" :key="salonPrefecture">
            <div class="prefecture-title">{{ salonPrefecture.prefecture }}</div>

            <div class="prefecture-container">
              <div class="salon-list-content" v-for="salon in salonPrefecture.salon" :key="salon.name">
                  <p class="content-shop-name">{{ salon.name }}</p>
                  <div class="content-shop-info">
                    〒{{  salon.postalCode }}<br>
                    {{ salon.address }}<br>
                    TEL:{{ salon.tel }}  <br class="sp-disp"> FAX:{{ salon.fax }}<br>
                    <div class="instagram" v-html="salon.instagram"></div>
                    <div class="line" v-html="salon.LINE"></div>
                    <!--{{ salon.hotpeppar }}
                    {{ salon.hotpeppar }}<br>-->
                    <div class="hotpeppar" v-html="salon.hotpeppar"></div>
                    {{ salon.access }}
                  </div>
                  
                  <div class="googlemap" v-html="salon.googleMap"></div>
              </div> <!-- 店舗 -->
            </div>
          </div><!-- 都道府県 -->
        </div>
      </div><!-- 地方 -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    // なし
  },
  data:function(){
    return{
      salonListTest:[],
      areaClassificationShow:{},
      salonList:[],
      headers: {
            /*'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*',*/
            crossDomain: true,
      }
    }
  },
  methods: {
  },
  created(){
    //this.salonList = require('./salonList.json')
    this.axios.get('./salonList.json')
    //this.axios.get('https://script.google.com/macros/s/AKfycbwX3Pg92Y0yzLA1eUU5t6HinqEOGnJwe0B_gX5SrJgAD9UA2B-z/exec', this.headers)
          .then(response => {
            this.salonList = response.data
            // サロンリストから地方区分ごとの表示・非表示の一覧を作成する。
            this.areaClassificationShow = Object.fromEntries(this.salonList.map(function(value){
              return [value.area,false]
            }))
          })
          .catch((e) => {
            alert(e);
          });
    
    
  }
}
</script>

<style scoped>
  @import "../../css/style.css";

  .salon-list-header{
    color: var(--main-color);
    text-align: center;

    margin:50px auto;
  }

  .salon-list-container{
    width: 80vw;
    left: 0;
    right: 0;
    margin: auto;

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .prefecture-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 80vw;
  }

  .prefecture-title{
    color:white;
    background-color: var(--main-color);
    
    font-weight: 600;
    max-width: 80vw;
    margin-bottom: 30px;

    padding:0.5em 0 0.5em 0.5em;
  }

  .googlemap{
    position: relative;
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    
  }

  /* 理由はわからないけど「scoped」だとiframeが子要素になっちゃうみたいで、ディープセレクタが必要 */
  /deep/ .googlemap iframe {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  .instagram{
    
    color: #707070;
    text-decoration: none;
  }

  .instagram:visited{

    color:#707070;
  }

  .line{
    
    color: #707070;
    text-decoration: none;
    height:auto;
  }

  .line:visited{

    color:#707070;
  }

  .hotpeppar{
    
    color: #707070;
    text-decoration: none;
  }

  .hotpeppar:visited{

    color:#707070;
  }

  /* PC表示 */
  @media screen and (min-width:821px){
    .sp-disp{
      display: none;
    }

    .area-classification-active{
      width: 100%;
    
    }

    .salon-list-title-main{
      font-size: 2.5rem;
      letter-spacing: 0.2em;

    }

    .salon-list-title-sub{
      font-size: 1rem;
      margin-top: 0.5em;
    }

    .area-classification{
      width: 48%;
      
    }

    .area-classification-button-active{
      color: white;
      width: 48%;
      height: 3em;
      line-height: 3em;
      font-size: 1.5rem;
      text-align: center;
      background-color: var(--main-color);
      font-weight: 600;
      margin-bottom: 30px;

      position: relative;

    }
    /* ボタンにプラスマークを付けるための疑似要素（アクティブ用） */
    .area-classification-button-active::before,
    .area-classification-button-active::after{
      display: block;
      content: "";
      position: absolute;
      top: 50%;
      left: 5%;
      width: 5%;
      height: 5%;
      /*margin: -8% 0 0 -42%;*/
      background: white;
    }

    .area-classification-button-active::after {
      transform: rotate(90deg);
    }

    .area-classification-button{
      color: var(--main-color);
      width: 100%;
      height: 3em;
      line-height: 3em;
      font-size: 1.5rem;
      text-align: center;
      background-color: var(--sub-color);
      font-weight: 600;

      border: solid 1px rgb(221, 221, 221);
      margin-bottom: 30px;

      position: relative;
    }

    /* ボタンにプラスマークを付けるための疑似要素（非アクティブ用） */
    .area-classification-button::before,
    .area-classification-button::after{
      display: block;
      content: "";
      position: absolute;
      top: 50%;
      left: 5%;
      width: 5%;
      height: 5%;
      /*margin: -8% 0 0 -42%;*/
      background: var(--main-color);
    }

    .area-classification-button::after {
      transform: rotate(90deg);
    }
    
    .salon-list-content{
      background-color: var(--sub-color);
      padding:40px 2%;
      
      min-width: 45%;
      margin-bottom: 30px;
    }

    .content-shop-name{
      color: var(--main-color);
      font-size: 36px;
      font-weight: 600;
      margin:0.8em auto;
    }

    .content-shop-info{
      line-height: 1.5em;
      margin-bottom: 1em;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .sp-disp{
      display: block;
    }

    .salon-list-title-main{
      font-size: 5vw;
      letter-spacing: 0.2em;

      margin-bottom: 0.3em;
    }

    .salon-list-title-sub{
      font-size: 2vw;
      margin-top: 1em;
    }

    .area-classification-active{
      width: 100%;
    
    }

    .area-classification{
      width: 48%;
      
    }

    .area-classification-button-active{
      color: white;
      width: 48%;
      height: 3em;
      line-height: 3em;
      font-size: 1rem;
      text-align: center;
      background-color: var(--main-color);
      font-weight: 600;

      margin-bottom: 30px;

      position: relative;

    }

    .area-classification-button{
      color: var(--main-color);
      width: 100%;
      height: 3em;
      line-height: 3em;
      font-size: 1rem;
      text-align: center;
      background-color: var(--sub-color);
      font-weight: 600;

      margin-bottom: 30px;

      position: relative;
    }

    /* ボタンにプラスマークを付けるための疑似要素（アクティブ用） */
    /* 横棒を2つ作る（1個を後で回転させてプラスに見えるようにするため） */
    .area-classification-button-active::before,
    .area-classification-button-active::after{
      display: block;
      content: "";
      position: absolute;
      top: 50%; /* 位置（上からの距離） */
      left: 5%; /* 位置（左からの距離） */
      width: 8%; /* 横棒の長さ */
      height: 5%; /* 横棒の高さ */
      /*margin: -8% 0 0 -42%;*/
      background: white;
    }
    /* 横棒を1つ90度回転させてプラスにする */
    .area-classification-button-active::after {
      transform: rotate(90deg);
    }

    /* ボタンにプラスマークを付けるための疑似要素（非アクティブ用） */
    .area-classification-button::before,
    .area-classification-button::after{
      display: block;
      content: "";
      position: absolute;
      top: 50%; /* 位置（上からの距離） */
      left: 5%; /* 位置（左からの距離） */
      width: 8%; /* 横棒の長さ */
      height: 5%; /* 横棒の高さ */
      /*margin: -8% 0 0 -42%;*/
      background: var(--main-color);
    }

    .area-classification-button::after {
      transform: rotate(90deg);
    }

    .salon-list-content{
      background-color: var(--sub-color);
      padding:2% 7% 5% 7%;
      border: solid 1px rgb(221, 221, 221);
      
      min-width: 86%;
      margin-bottom: 30px;
    }

    .content-shop-name{
      color: var(--main-color);
      font-size: 6vw;
      font-weight: 600;
      margin:0.3em auto;
    }

    .content-shop-info{
      font-size: 3vw;
      line-height: 1.5em;
      margin-bottom: 1em;
    }
  }
</style>